import React from "react";
import { GlobalContainer } from "../../Global/layout";
import { LineHeading } from "../../LineHeading";
import { StyledHeadingh2 } from "../../Global/headings";
import { BlackButtonLink } from "../../Global/button";
import { OvercomeChallengesContainer, OvercomeDescription } from "./style";

const OvercomeChallenges = ({ data, sectionCount }: any) => {
  return (
    <section className="light">
      <GlobalContainer>
        <LineHeading title={data?.lineHeading} number={data?.lineNumber} />
        <OvercomeChallengesContainer>
          <StyledHeadingh2 text={data?.heading} />
          <OvercomeDescription
            data-aos="fade-up"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />
          <BlackButtonLink data-aos="fade-up" to="#Form">
            {data?.downloadButton?.title}
          </BlackButtonLink>
        </OvercomeChallengesContainer>
      </GlobalContainer>
    </section>
  );
};

export default OvercomeChallenges;
